




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import dataStore from "@/store";
import AccountStore from "@/modules/account/store";

import PenaltyRuleHistoryRecord from "./History/Record.vue";

import FactoryInvoiceStore from "../../store";
import HistoryRecord from "../../penalty-rule-history-record.model";

@Component({
  components: {
    LoadingSpinner,
    PenaltyRuleHistoryRecord,
  },
})
export default class PenaltyRuleHistory extends Vue {
  @Prop({ required: true })
  public readonly factoryId!: string;

  private fIsLoading = true;

  private fAccountDataStore: AccountStore;
  private fFactoryInvoiceDataStore: FactoryInvoiceStore;

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  constructor() {
    super();

    this.fAccountDataStore = getModule(AccountStore, dataStore);
    this.fFactoryInvoiceDataStore = getModule(FactoryInvoiceStore, dataStore);
  }

  get historyRecords(): HistoryRecord[] {
    return this.fFactoryInvoiceDataStore.getPenaltyRuleHistoryRecordsByFactoryId(
      this.factoryId
    );
  }

  private async getFactoryData(factoryId: string) {
    const historyRecords = await this.fFactoryInvoiceDataStore.loadPenaltyRuleHistoryRecordsByFactoryId(
      { factoryId }
    );

    if (historyRecords.length < 1) {
      return;
    }

    const userIds: string[] = [];

    historyRecords.forEach((item) => {
      if (!userIds.includes(item.user)) {
        userIds.push(item.user);
      }
    });

    await Promise.all([
      this.fAccountDataStore.loadUserInfosByIds(userIds),
      this.fAccountDataStore.loadUserRolesByUserId({ userIds: userIds }),
      this.fAccountDataStore.loadRoles(),
      this.fFactoryInvoiceDataStore.loadHistoryActions(),
    ]);
  }

  @Watch("factoryId", { immediate: true })
  private async _onFactoryIdChange() {
    if (!this.factoryId) {
      return;
    }

    this.fIsLoading = true;

    await this.getFactoryData(this.factoryId);

    this.fIsLoading = false;
  }
}
